export const PAGESIZES = [15, 25, 50, 100];
export const pilotSellers = [
  9246150400, 9043000045, 9935531061, 9991717009, 8558861868, 8595737262, 9654133839, 9999080225,
  8373941455, 9871719450, 9870290501, 9811854175, 9000016543, 9823555000, 7982178175, 7418332478,
  9982989349, 7017759952, 8802671009, 9815541044, 9915362724, 9810024469, 9875495453, 9686855009,
  9691163230, 6201622009, 7987963958, 9811422242, 8178706474, 9584218100, 9448480000, 9999691341,
  8878066996, 9896150127, 9810922577, 8041473301, 9826182000, 9886048988, 8722397987, 9928218383,
  8951809010, 9935038100, 9849081487, 8823074060, 9681126511, 7780222713, 6383626507, 8369123759,
  9094066467, 9044067839, 9311328777, 9989675714, 9839236111, 9814102841, 9826064419, 9888080277,
  9344983859, 9871195160, 9837068918, 7362990297, 9811191151, 9681047696, 9997770987, 8639752035,
  7004200553, 7737588506, 8874797976, 7666406406, 9674889944, 9321331205, 9810138823, 9825079521,
  9891653590, 9898507487, 9988077720, 8757103787, 9250398390, 9582060000, 8607044014, 8839148619,
];

export const blockSellerList = [];

export const errorColor = '#f44336';
export const successColor = '#4caf50';
